import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { capitalize } from 'lodash';

import { getOauthService, getEmailAddress } from '../../../api/Users/user-operations';

import Styles from './styles';

const OAuthUserProfile = ({ user }) => {
  const userService = getOauthService(user);
  return (
    <Styles.OAuthUserProfile>
      <div key={userService} className={`LoggedInWith ${userService}`}>
        <img src={`/${userService}.svg`} alt={userService} />
        <p>{`You're logged in with ${capitalize(
          userService
        )} using the email address ${getEmailAddress(user)}.`}</p>
        <Button
          className={`btn btn-${userService}`}
          href={
            {
              facebook: 'https://www.facebook.com/settings',
              google: 'https://myaccount.google.com/privacy#personalinfo',
              esri: 'https://my.esri.com/#/profile/info'
            }[userService]
          }
          target="_blank"
        >
          Edit Profile on {capitalize(userService)}
        </Button>
      </div>
    </Styles.OAuthUserProfile>
  );
};

OAuthUserProfile.propTypes = {
  user: PropTypes.object.isRequired
};

export default OAuthUserProfile;
